// Angular
import { provideHttpClient, withInterceptors } from '@angular/common/http';

// Third party
import {
  ActionReducer,
  MetaReducer,
  Store,
  provideState,
  provideStore
} from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';

// Local library
import { Environment as env } from '@amwager/util-ts'
import {
  APP_TITLE,
  BASE_URL,
  COMMON_FEATURE_KEY,
  CancelApiService,
  CommonEffects,
  CommonFacade,
  DEFAULT_ROLE_ID,
  DOMAIN,
  ENABLE_ANALYTICS,
  ENABLE_COMPONENT_VIEW,
  ENABLE_DEV_TOOLS_REDUX,
  ENVIRONMENT,
  EPROTECT,
  HOME_DIRECTORY,
  HttpService,
  ORG_ID, PUSHER,
  PusherService,
  SMARTLOOK,
  STABLE_URL,
  SessionService,
  ToteAccountAPIService,
  UI,
  commonReducer,
  httpInterceptorFn
} from '@amwager/data-access';
import { CommonModule } from '@angular/common';



/**
 * @description
 *
 * For testing purposes.
 */
declare global {
  interface Window {
    name: string,
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    Cypress: any
    store: Store
  }
}

const environment = env.Environment;

/**
 * @description
 * Debugging for NgRx.
 *
 * @param reducer ActionReducer
 * @returns ActionReducer
 */
/* eslint-disable  @typescript-eslint/no-explicit-any */
const debug = (reducer: ActionReducer<any>): ActionReducer<unknown> => {
  return function(state, action) {
    // console.log('action', action);
    // console.log('state', state);
    // console.log('window:', window.store);
    return reducer(state, action);
  };
}

/**
 * @description
 * Meta debugging for NgRx.
 */
/* eslint-disable  @typescript-eslint/no-explicit-any */
const metaReducers: MetaReducer<any>[] = [debug];


export class SharedModule {
  static storeProvider = provideStore(
    {},
    {
      metaReducers: window.Cypress ? metaReducers : [],
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictStateSerializability: false,
        strictActionSerializability: false,
        strictActionWithinNgZone: false,
        strictActionTypeUniqueness: true,
      },
  });
  static effectsProvider = provideEffects([]);
  static storeDevtoolsProvider = provideStoreDevtools({
    maxAge: false,
    logOnly: false,
    autoPause: true,
    features: {
      pause: false,
      lock: true,
      persist: true
    }
  });
  static ngrxProviders = [
    // Root state
    this.storeProvider,
    this.effectsProvider,
    environment.enableDevToolsRedux
      ? this.storeDevtoolsProvider
      // : this.storeDevtoolsProvider, // prod/staging: to remove
      : [],

    // Feature common state
    CommonFacade,
    provideState(COMMON_FEATURE_KEY, commonReducer),
    provideEffects(CommonEffects),
  ];

  static tokenProviders = [
    { provide: DOMAIN, useValue: environment.domain },
    { provide: BASE_URL, useValue: environment.urlAPI },
    { provide: DEFAULT_ROLE_ID, useValue: environment.defaultRoleId },
    { provide: UI, useValue: environment.ui },
    { provide: ORG_ID, useValue: environment.orgId },
    { provide: APP_TITLE, useValue: environment.appTitle },
    { provide: ENABLE_ANALYTICS, useValue: environment.enableAnalytics },
    { provide: ENABLE_COMPONENT_VIEW, useValue: environment.enableComponentView },
    { provide: STABLE_URL, useValue: environment.urlAPIStable },
    { provide: HOME_DIRECTORY, useValue: environment.homeDirectory },
    { provide: ENABLE_DEV_TOOLS_REDUX, useValue: environment.enableDevToolsRedux },
    { provide: PUSHER, useValue: environment.pusher },
    { provide: ENVIRONMENT, useValue: environment.environment },
    { provide: EPROTECT, useValue: environment.eProtect },
    { provide: SMARTLOOK, useValue: environment.smartlook },
  ];

  static commonProviders = [
    CommonModule,
    ...this.ngrxProviders,
    ...this.tokenProviders,
    SessionService,
    CancelApiService,
    ToteAccountAPIService,
    // CommonFacade,
    // AuthFacade,
    provideHttpClient(
      withInterceptors([httpInterceptorFn])
    ),
    HttpService,
    PusherService,
    ToteAccountAPIService
  ];
}
